import React from 'react';
import { Box, Typography, Link, useTheme } from '@mui/material';


const Footer = () => {
 const theme = useTheme(); // Hook to access the theme object


 return (
   <Box
     component="footer"
     sx={{
       py: 2,
       px: 2,
       mt: 'auto',
       // UPDATED: purple gradient to match the new landing/sign-in design
       background: 'linear-gradient(135deg, #A78BFA 0%, #7C3AED 100%)',
       color: 'white',
       textAlign: 'center'
     }}
   >
     <Typography variant="body2">
       {'© Copyright 2024-26 - www.OmneVu.com | By using or viewing this website or app you are governed by these '}
       <Link
         href="/tnc"
         color="inherit"
         underline="always"
       >
         Terms & Conditions and Privacy Policy
       </Link>
     </Typography>
   </Box>
 );
};


export default Footer;
